import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "User"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 3C14.0711 3 15.75 4.67893 15.75 6.75C15.75 8.82107 14.0711 10.5 12 10.5C9.92893 10.5 8.25 8.82107 8.25 6.75C8.25 4.67893 9.92893 3 12 3ZM12 1.5C9.1005 1.5 6.75 3.85051 6.75 6.75C6.75 9.6495 9.1005 12 12 12C14.8995 12 17.25 9.6495 17.25 6.75C17.25 3.85051 14.8995 1.5 12 1.5ZM19.5 22.5H18V18.75C18 17.7554 17.6049 16.8016 16.9017 16.0983C16.1984 15.3951 15.2446 15 14.25 15H9.75C7.67893 15 6 16.6789 6 18.75V22.5H4.5V18.75C4.5 15.8505 6.85051 13.5 9.75 13.5H14.25C17.1495 13.5 19.5 15.8505 19.5 18.75V22.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/User.vue"]]);
